<header id="banner">
  <div class="title">
    <span class="acronym">N-CLAS</span>
    <div class="text">
      <h1>National Critical Loads Assessment by Site</h1>
      <h2>
        High resolution, spatially explicit critical load and exceedance mapping
        to inform sustainable forest management
      </h2>
    </div>
  </div>

  <span class="spacer"></span>

  <img src="https://nclas.ecosheds.org/images/shield_color.png" class="logo" />
  <img src="https://nclas.ecosheds.org/images/USDA%20color.jpg" class="logo" />
</header>
<nav>
  <a
    *ngFor="let link of links; let i = index"
    href="#"
    [ngClass]="{ active: i === 0 }"
    >{{ link }}</a
  >
</nav>
<div class="toolbar">
  <button mat-icon-button (click)="refresh()">
    <mat-icon>refresh</mat-icon>
  </button>

  <button mat-icon-button>
    <mat-icon>list</mat-icon>
  </button>

  <button mat-icon-button>
    <mat-icon>assessment</mat-icon>
  </button>

  <button mat-icon-button>
    <mat-icon>print</mat-icon>
  </button>

  <button mat-icon-button>
    <mat-icon>settings</mat-icon>
  </button>

  <button mat-icon-button>
    <mat-icon>info</mat-icon>
  </button>
  <span class="spacer"></span>

  <mat-form-field>
    <mat-label>Map Baselayer</mat-label>
    <mat-select>
      <mat-option *ngFor="let layer of options.mapLayers.base" [value]="layer">
        {{ layer }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Abiotic Map Layers</mat-label>
    <mat-select multiple>
      <mat-option
        *ngFor="let layer of options.mapLayers.abiotic"
        [value]="layer"
      >
        {{ layer }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>CL & Exceedance Map Layers</mat-label>
    <mat-select> </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Search map</mat-label>
    <input matInput type="search" />
  </mat-form-field>
  <button mat-icon-button>
    <mat-icon>search</mat-icon>
  </button>
</div>
<mat-drawer-container class="example-container" autosize>
  <mat-drawer mode="side" opened>
    <div class="progress-indicator">
      <span
        *ngFor="let step of steps; let i = index"
        [class]="'step-' + (i + 1)"
        [ngClass]="{ visited: maxStep > i }"
      ></span>
    </div>
    <mat-accordion>
      <mat-expansion-panel
        *ngFor="let step of steps; let i = index"
        hideToggle
        [class]="'step-' + (i + 1)"
        [expanded]="currentStep === i + 1"
        (opened)="changeStep(i + 1)"
        [disabled]="!isStepEnabled(i + 1)"
      >
        <mat-expansion-panel-header>
          <mat-icon>label</mat-icon>
          <mat-panel-title>{{ step }}</mat-panel-title>
          <mat-panel-description *ngIf="isStepCompleted(i + 1)">
            {{ getStepSummary(i + 1) }}</mat-panel-description
          >
        </mat-expansion-panel-header>

        <div [ngSwitch]="step">
          <ng-container *ngSwitchCase="'Areas'">
            <form class="example-form" [formGroup]="area.formGroup">
              <mat-form-field appearance="fill">
                <mat-label>Area Layer</mat-label>
                <mat-select formControlName="layer">
                  <mat-option
                    *ngFor="let layer of options.areaLayers"
                    [value]="layer"
                    >{{ layer }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="area.controls.layer.value">
                <input
                  type="text"
                  matInput
                  [placeholder]="'Search ' + area.controls.layer.value"
                  formControlName="name"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let option of filteredAreas | async"
                    [value]="option"
                  >
                    {{ option }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </form>
          </ng-container>

          <ng-container *ngSwitchCase="'Ecosystem Components'">
            <ul class="checkbox-list">
              <li *ngFor="let c of options.components">
                <mat-checkbox [(ngModel)]="components[c]">{{ c }}</mat-checkbox>
              </li>
            </ul>
          </ng-container>

          <ng-container *ngSwitchCase="'Deposition'">
            <ul class="checkbox-list">
              <li *ngFor="let d of options.depositions">
                <mat-checkbox [(ngModel)]="depositions[d]">{{
                  d
                }}</mat-checkbox>
              </li>
            </ul>
          </ng-container>

          <ng-container *ngSwitchCase="'CL Type'">
            <div *ngIf="components.Lichens">
              <h3>Lichens:</h3>
              <ul class="checkbox-list">
                <li *ngFor="let t of options.clTypes.lichens">
                  <mat-checkbox [(ngModel)]="clTypes[t]">{{ t }}</mat-checkbox>
                </li>
              </ul>
            </div>
            <div *ngIf="components.Trees">
              <h3>Trees:</h3>
              <ul class="checkbox-list">
                <li *ngFor="let t of options.clTypes.trees">
                  <mat-checkbox [(ngModel)]="clTypes[t]">{{ t }}</mat-checkbox>
                </li>
              </ul>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'Species'">
            <h3>Trees:</h3>
            <div *ngIf="!allSpecies">
              <mat-form-field>
                <input
                  type="text"
                  matInput
                  placeholder="Filter species"
                  [formControl]="speciesFilter"
                />
              </mat-form-field>
              <ul class="checkbox-list">
                <li *ngFor="let o of filteredSpecies | async">
                  <mat-checkbox [(ngModel)]="species[o]">{{ o }}</mat-checkbox>
                </li>
              </ul>
            </div>
            <mat-checkbox [(ngModel)]="allSpecies">All Species</mat-checkbox>
          </ng-container>

          <ng-container *ngSwitchCase="'Outputs'">
            <div *ngIf="components.Trees">
              <h3>Tree aggregation method</h3>
              <ul class="checkbox-list">
                <li *ngFor="let o of options.outputs">
                  <mat-checkbox [(ngModel)]="outputs[o]">{{ o }}</mat-checkbox>
                </li>
              </ul>
            </div>
            <p class="button-column">
              <button mat-raised-button color="accent">Preview outputs</button>
            </p>
          </ng-container>

          <ng-container *ngSwitchCase="'Results'">
            <p class="button-column">
              <button mat-raised-button color="accent">View maps</button>
              <button mat-raised-button color="accent">
                View related reports
              </button>
            </p>

            <p class="button-column">
              <button mat-raised-button color="primary">
                Download map data
              </button>
              <button mat-raised-button color="primary">
                Download map images
              </button>
            </p>
          </ng-container>

          <p *ngSwitchDefault>This is just placeholder text</p>
        </div>

        <mat-action-row>
          <button mat-icon-button (click)="openInfoPanel()">
            <mat-icon color="primary">help</mat-icon>
          </button>
          <span class="spacer"></span>
          <button
            *ngIf="steps.length > i + 1"
            mat-raised-button
            color="primary"
            [disabled]="!isNextEnabled(i + 1)"
            (click)="nextStep()"
          >
            Next
          </button>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-drawer>
  <mat-drawer-content>
    <div id="map" [class]="'demo-' + getDemoStep()"></div>
  </mat-drawer-content>
</mat-drawer-container>
